<template>
    <!-- <div v-cloak v-if="files.length" class="allowDeselect sdpi-item-wrapper CenteredContainer"> -->
    <div v-cloak class="allowDeselect sdpi-item-wrapper CenteredContainer" @click.stop.prevent.self="handleSelection($event, false)">
        <h3>Icons</h3>
        <section>
            <div class="wrap tools">
                <div class="tt">
                    <div :class="{ active: !iscard }" class="toolicon list-icon" @click.stop.prevent="toggleListType"></div>
                    <div :class="{ active: iscard }" class="toolicon grid-icon" @click.stop.prevent="toggleListType"></div>
                </div>
                <div class="tagarea">
                    <div class="flexrow">
                        <span>Tags:</span>
                        <input v-model.lazy="allTags" type="text" placeholder="tag1,tag2,...!" />
                        <button :disabled="allTags.length < 2" @click.stop.prevent="setAllProps('tags', allTags)">Set all tags</button>
                    </div>
                </div>
                <div class="tooltext"># icons: {{ files.length }}</div>
            </div>
            <header v-if="!iscard" class="xrow" :class="{ sdList: !iscard }">
                <div class="col mini">Icon</div>
                <div class="col cursor-pointer" :class="{ sortedBy: isSortedBy('fileName') }" @click="doSort('fileName', $event)">Filename</div>
                <!-- <div v-if="" class="col">Info</div> -->
                <div class="col cursor-pointer" :class="{ sortedBy: isSortedBy('name') }" @click="doSort('name', $event)">Name</div>
                <div class="col">Tags</div>
                <div class="col cursor-pointer fullpath" :class="{ sortedBy: isSortedBy('fullPath') }" @click="doSort('fullPath', $event)">Path</div>
                <div class="col remove remove-item-empty"></div>
            </header>
            <draggable  
                v-if="shouldDraw"
                :move="onMoveCallback"
                :updated="updated"
                tag="div"
                class="list-groupA"
                :value="files"
                :sort="false"
                group="files"
                v-bind="dragOptions"
                
                xxxhandle=".handle"
                :component-data="getComponentData()"
                :class="{ dragging: drag }"
                
                @start="onStart"
                @end="onEnd"
                @choose="onChoose"
            >
                <!-- needed: name, thumbNail, tags, fullPath -->
                <transition-group type="transition" :name="!drag ? 'xxflip-list' : null" class="listType" :class="{ cardList: iscard, sdList: !iscard }" @click.stop.prevent="handleSelection($event, false)">
                    <!-- <div class="xrow" v-for="(file, i) in files" :key="i" v-bind:class="{ card: iscard, selected: file.isSelected }" @mousedown.stop.prevent="mouseDown($event, file, i)" @click.stop.prevent="handleSelection($event, file, i)"> -->
                    <!-- <div v-for="(file, i) in files" :key="i" class="xrow" :class="{ card: iscard, selected: file.isSelected }" @mousedown="mouseDown($event, file, i)" @click.stop.prevent="handleSelection($event, file, i)"> -->
                    <!-- <div key="hello"> -->
                    <div v-for="(file, i) in files" :key="i+0" class="xrow" :class="{ card: iscard, selected: file.isSelected }" @click.stop.prevent="handleSelection($event, file, i)">
                        <div class="col mini">
                            <img v-if="file.objectURL" class="thumbnail" :src="file.objectURL" :alt="file.file.name || file.name" :title="file.file.name || file.name" />
                            <img
                                v-show="hasThumbNail(file)"
                                class="thumbnail"
                                :src="getThumbNail(file)"
                                xrc="file.file.thumbNail || file.thumbNail"
                                :alt="file.file.name || file.name"
                                :title="file.file.name || file.name"
                            />
                        </div>
                        <template v-if="iscard">
                            <div :class="{ columns: iscard, row: !iscard}">
                                <div data-title="Filename" class="col">
                                    <div>
                                        {{ file.file.name || file.name }}
                                    </div>
                                </div>
                                <div data-title="Name" class="col">
                                    <input v-model="file.name" type="text" class="Name" />
                                </div>
                                <div data-title="Tags" class="col">
                                    <input v-model="file.tags" type="text" class="tax" />
                                </div>
                                <div data-title="FullPath" class="col fullpath">
                                    <div class="path">{{ file.fullPath }}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div data-title="Filename" class="col">
                                {{ file.file.name || file.name }}
                            </div>
                            <div data-title="Name" class="col">
                                <input v-model="file.name" type="text" class="Name" />
                            </div>
                            <div data-title="Tags" class="col">
                                <input v-model="file.tags" type="text" class="tax" />
                            </div>
                            <div data-title="FullPath" class="col fullpath">
                                <div class="path">{{ file.fullPath }}</div>
                            </div>
                            <div v-if="file.imageinfo " data-title="Info" class="col">
                                {{ file.imageinfo }} {{ updated }}
                            </div>
                        </template>
                        <div class="col remove">
                            <div class="remove-item" @mousedown.stop.prevent="" @click.stop.prevent="doRemoveIcon($event, file, i)">×</div>
                        </div>
                    </div>
                    <!-- </div> -->
                </transition-group>
            </draggable>
        </section>
    </div>
</template>

<script>

/* eslint-disable no-unused-vars */

 import draggable from 'vuedraggable'

export default {
    name: 'FilelistComponent',
    display: 'Table',
    order: 8,
    components: {
        draggable
    },
    props: { 
        iconPack: {
            type: Object,
            default() {return {}}
        }, 
        files: {
            type: Array,
            default() {return []},
        }, 
        updated: {
            type: Number ,
           default() {return 0}
        },
         shouldDraw: {
            type: Boolean ,
           default() {return true}
        }
    },
    data() {
        // window.fl = this;
        return {
            iscard: true,
            drag: false,
            allTags:'',
        };
    },
    
    computed: {
        dragOptions() {
            return {
                animation: 0,
                // group: 'description',
                disabled: false,
                ghostClass: 'ghost',
                multiDrag: false,
                selectedClass: 'selected',
                removeCloneOnHide: 'true',
                lastClickedIdx: 0,
            };
        },
    },
    watch: {
        allTags(val) {
            const tags = this.$options.filters.tagify(val);
            if(tags !== this.allTags) {
                this.allTags = tags;
            }
        },
    },
    methods: {
        logItems(arr) {
            const x = [0, 1, 2, 3, 4, 5];
            console.log(x.map((i) => arr[i].fileName));
        },
        
        setAllProps(prop, value) {
            const arrSelection = this.files.filter(i => i.isSelected);
            const filesToProcess = arrSelection && arrSelection.length ? arrSelection : this.files;
            for (let r of filesToProcess) {
                // if (r.hasOwnProperty(prop)) {
               if (Object.prototype.hasOwnProperty.call(r, prop)) {
                    if (Array.isArray(value)) {
                        r[prop] = value;
                    } else {
                        r[prop] = value.split(",");
                    }
                }
            }
        },
        insertAtIndex(arr, index, items) {
            arr.splice(arr, index, ...items);
            this.logItems(arr);
        },
        insertItemsAtIndex(arr, index, items) {
            return [...arr.slice(0, index), ...items, ...arr.slice(index)];
        },
        onChoose(evt) {
            // console.log('component::onChoose', evt);
        },
        onStart(evt) {
            // console.log('onStart', evt);
            this.drag = true;
            this.$emit('draggingchanged', this.drag);
        },
        onEnd(evt) {
            const selectedItems = this.files.filter((i) => i.isSelected);
            const notSelectedItems = this.files.filter((i) => !i.isSelected);

            let files = this.insertItemsAtIndex(notSelectedItems, evt.newIndex, selectedItems);

            this.files.splice(0, this.files.length);
            files.map((f) => this.files.push(f));

            this.drag = false;
            this.$emit('draggingchanged', this.drag);
             this.lastClickedIdx = evt.newIndex;
        },
        onMoveCallback(evt, originalEvent) {
            // console.log('component::onMoveCallback2222', evt, evt.item, originalEvent);
            // return false; — for cancel
        },
        handleChange(evt) {
            console.log('handleChange', evt);
        },
        inputChanged(value) {
            this.activeNames = value;
            console.log('inputChanged', value);
        },
        getComponentData() {
            // console.log('dnd:getComponentData()');
            return {
                on: {
                    change: this.handleChange,
                    input: this.inputChanged,
                },
                attrs: {
                    wrap: true,
                },
                props: {
                    value: this.activeNames,
                },
            };
        },
        
        deselectAll() {
            this.files.forEach(fl => (fl.isSelected = false));
        },
        handleSelection(evt, f, fileIdx) {
            // if clicked a control (e.g. 'Set all tags')
            if (["INPUT", "BUTTON"].includes(evt.target.nodeName)) {
                // console.log("clicked in CONTROL");
                return;
            }

            if (f == false || evt.target.classList.contains("allowDeselect")) {
                return this.deselectAll();
            }

            if (!evt.shiftKey && !evt.metaKey) {
                // if the current item is already selected do nothing
                if (f && f.isSelected) return;
                this.deselectAll();
            }

            if (evt.shiftKey) {
                let isSel = !f.isSelected;
                let [toIndex, fromIndex] =
                    fileIdx <= this.lastClickedIdx
                        ? [this.lastClickedIdx, fileIdx]
                        : [fileIdx, this.lastClickedIdx];
                for (let i = fromIndex; i <= toIndex; i++) {
                    this.iconPack.icons[i].isSelected = isSel;
                }
            } else {
                f.isSelected = !f.isSelected;
            }
            this.lastClickedIdx = fileIdx;
        },

        isSortedBy(value) {
            return this.iconPack.__sortState == value;
        },
        doSort(sortField) {
            this.iconPack.sortIcons(sortField);
        },
        doRemoveIcon(evt, f) {
            evt.stopPropagation();
            evt.preventDefault();

            if (evt.altKey) {
                this.$emit('doRemoveFromAllIcons', this.files);
                this.files.splice(0, this.files.length);
            } else {
                this.$emit('doRemoveFromAllIcons', f);
                const index = this.files.indexOf(f);
                if (index > -1) {
                    this.files.splice(index, 1);
                }
            }
        },
        toggleListType() {
            this.iscard = !this.iscard;
        },
        getThumbNail(file) {
            if (file && file.thumbNail) {
                return file.thumbNail.objectURL ? file.thumbNail.objectURL : file.thumbNail;
            }
            if (file.file && file.file.thumbNail) {
                return file.file.thumbNail.objectURL ? file.file.thumbNail.objectURL : file.file.thumbNail;
            }
        },
        hasThumbNail(file) {
            if (file && file.thumbNail) {
                return true;
            }
            if (file.file && file.file.thumbNail) {
                return true;
            }
            const b = !!(file.file.thumbNail || file.thumbNail);
            if (b) {
                console.log('thumb: ', file);
            }
        },
        isEditable(col) {
            return ['fileName', 'tags'].includes(col.field);
        },
        add() {
            this.$emit('update:files', this.files.length);
        },
    },
};
</script>

<style scoped>
</style>
